import {
  Divider,
  GKButton,
  GKTextField,
  Grid2,
  PhoneInput,
  Typography,
} from "components";
import { useRegistration } from "hooks/useRegistration";
import { Controller } from "react-hook-form";
import useDocumentTitle from "utils/useDocumentTitle";

const Register = () => {
  useDocumentTitle("Register");

  const { isLoading, navigate, form, onSubmit, hasError, setHasError } =
    useRegistration();

  form.watch();

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <Grid2 container gap={3} justifyContent={"center"}>
        <Grid2
          size={12}
          position={"relative"}
          justifyContent={"center"}
          alignItems={"center"}
          gap={"10px"}
          display={"flex"}
          flexDirection={"column"}
        >
          <Typography
            fontWeight={700}
            fontSize={24}
            color={"var(--black)"}
            className="textUnderlineLogin"
            sx={{
              "&.textUnderlineLogin::before": {
                width: "150px !important",
              },
            }}
          >
            Give A Start !
          </Typography>
          <Typography color={"var(--black)"} textAlign={"center"}>
            Welcome to GridKey, please enter your phone number to continue
          </Typography>
        </Grid2>
        <Grid2 size={{ xs: 12, md: 7, sm: 8 }} container spacing={1}>
          <Grid2 size={12}>
            <Controller
              name="phone"
              control={form.control}
              rules={{
                required: {
                  value: true,
                  message: "Please enter phone number",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <PhoneInput
                  {...field}
                  onSelectChange={(event: any) => {
                    form.setValue("countryCode", event);
                  }}
                  inputLabel="Phone Number"
                  onTextChange={(event: any) => {
                    field.onChange(event);
                  }}
                  requiredField
                  onTextValue={field.value}
                  onSelectValue={form.getValues("countryCode")}
                  error={!!error || hasError}
                  helperText={error?.message}
                  hasError={hasError}
                  setHasError={setHasError}
                />
              )}
            />
          </Grid2>
          <Grid2 size={12}>
            <Controller
              name="email"
              control={form.control}
              render={({ field, fieldState: { error } }) => (
                <GKTextField
                  {...field}
                  inputLabel={"Email"}
                  error={!!error}
                  helperText={!!error && error.message}
                />
              )}
            />
          </Grid2>
          <Grid2 size={12} textAlign={"end"}>
            <GKButton
              loading={isLoading}
              type="submit"
              disabled={hasError}
              size="medium"
              variant="contained"
            >
              Continue
            </GKButton>
          </Grid2>
        </Grid2>
        <Grid2 size={12}>
          <Typography color={"var(--black)"} fontSize={12} textAlign={"center"}>
            By clicking continue, you agree to our{" "}
            <GKButton
              style={{ padding: 0 }}
              onClick={() => navigate("/privacy-policy")}
            >
              terms & conditions
            </GKButton>
          </Typography>
          <Divider style={{ margin: "6px 0" }} />
          <Typography color={"var(--black)"} fontSize={12} textAlign={"center"}>
            Already have an account?
            <GKButton
              style={{ padding: 0 }}
              onClick={() => {
                navigate("/login");
              }}
            >
              Sign In
            </GKButton>
          </Typography>
        </Grid2>
      </Grid2>
    </form>
  );
};

export default Register;
